import { AdminAuthContext as e } from "../context/AdminAuthContext.mjs";
import { setHasAdminSession as t } from "../queries/admin/adminSessionFlag.mjs";
import { useAdminMeQuery as n } from "../queries/admin/useAdminMeQuery.mjs";
import { useEffect as r, useMemo as i } from "react";
import { jsx as a } from "react/jsx-runtime";
//#region src/provider/AdminAuthProvider.tsx
var o = ({ children: o }) => {
	let { data: s, isLoading: c, isError: l } = n();
	r(() => {
		l ? t(!1) : s?.admin && t(!0);
	}, [l, s]);
	let u = i(() => ({
		admin: !l && s?.admin ? s.admin : null,
		isAuthenticated: !l && !!s?.admin,
		isLoading: c
	}), [
		s,
		c,
		l
	]);
	return /* @__PURE__ */ a(e.Provider, {
		value: u,
		children: o
	});
};
//#endregion
export { o as AdminAuthProvider };
